(() => {
  const normalize = anchor => {
    const raw = anchor.getAttribute('href');
    if (!raw || !raw.includes('/products/')) return;
    const q = raw.indexOf('?');
    const clean = q < 0 ? raw : raw.slice(0, q + 1) + raw.slice(q + 1).replace(/\?(?=(?:variant|option_values)=)/g, '&');
    const url = new URL(clean, location.href);
    if (url.origin !== location.origin) return;
    const variants = url.searchParams.getAll('variant');
    if (variants.length > 1) url.searchParams.set('variant', variants[variants.length - 1]);
    ['_pos', '_fid', '_ss'].forEach(key => url.searchParams.delete(key));
    const next = url.pathname + url.search + url.hash;
    if (raw !== next) anchor.setAttribute('href', next);
  };
  const scan = root => root.querySelectorAll('a[href*="/products/"]').forEach(normalize);
  scan(document);
  document.addEventListener('pointerdown', event => {const a=event.target.closest('a[href]');if(a)normalize(a);}, {capture:true,passive:true});
  document.addEventListener('focusin', event => {const a=event.target.closest('a[href]');if(a)normalize(a);});
  document.addEventListener('shopify:section:load', event=>scan(event.target));
  document.addEventListener('facet:change', ()=>scan(document));
})();
